export default "__VITE_ASSET__3fb07390__"